// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (): Promise<Record<string, any>> =>
  new Promise((resolve, reject) => {
    (function waitForGoogleMaps(retries = 0) {
      if (window.google && window.google.maps) {
        resolve(window.google.maps);
        return;
      }

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'MAPS_API_ERROR' does not exist on type '... Remove this comment to see the full error message
      if (window.MAPS_API_ERROR) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'MAPS_API_ERROR' does not exist on type '... Remove this comment to see the full error message
        reject(new Error(window.MAPS_API_ERROR));
      }

      // retry for 10s
      if (retries > 100) {
        reject(new Error('TIMEOUT'));
      }

      setTimeout(waitForGoogleMaps, 100, retries + 1);
    })();
  });
